// extracted by mini-css-extract-plugin
export default {"container":"style_container__ZQZt+","header":"style_header__TQMuG","subtitle":"style_subtitle__6eAd0","content":"style_content__6IdXs","loadMore":"style_loadMore__x7vDi"};